import { useMutation } from '@apollo/client'
import { DeleteTestSession, DeleteTestSessionVariables } from '../../types'
import { DELETE_TEST_SESSION } from './operations'

interface Props {
  id: string
  onCompleted?: (data: DeleteTestSession) => void
}

export const useDeleteTestSession = ({ onCompleted, id }: Props) =>
  useMutation<DeleteTestSession, DeleteTestSessionVariables>(DELETE_TEST_SESSION, {
    variables: {
      id,
    },
    onCompleted,
  })
